import React from "react";
import App from "./App";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { redirectDeeplinkHostToStore } from "./services/storeRedirect";

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <App/>,
//   },
// ]);

const queryClient = new QueryClient();

// Deeplink host without the app installed -> app store. Skip rendering, we are leaving.
if (!redirectDeeplinkHostToStore()) {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </QueryClientProvider>
    </React.StrictMode>
  );
}
